.table {
  min-width: 0;
}

.name-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 200px;
  max-width: 560px;
}

.name-main {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--primary_text);
  font: inherit;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
  overflow-wrap: anywhere;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  &:focus-visible {
    outline: 2px solid var(--interactive_focus);
    outline-offset: 2px;
    border-radius: var(--control_radius);
  }
}

.name-sub {
  color: var(--secondary_text);
  font-size: 12px;
  line-height: 18px;
  overflow-wrap: anywhere;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
}

.chip {
  display: inline-flex;
  padding: 1px 7px;
  border: 1px solid var(--app-border-strong);
  border-radius: var(--control_radius);
  background: var(--app-surface-muted);
  color: var(--primary_text);
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
}

.chip-feature {
  color: var(--secondary_text);
  font-size: 12px;
  line-height: 20px;
}

.status {
  --company-status-color: var(--secondary_text);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 24px;
  color: var(--primary_text);
  font-size: 13px;
  line-height: 20px;
  white-space: nowrap;
}

.status-dot {
  width: 6px;
  height: 6px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--company-status-color);
}

.status--ok {
  --company-status-color: var(--status-success-fg);
}

.status--warn {
  --company-status-color: var(--status-warning-fg);
}

.status--bad {
  --company-status-color: var(--status-danger-fg);
  color: var(--status-danger-fg);
}

.muted {
  color: var(--secondary_text);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.action-button.action-button {
  width: 32px;
  height: 32px;
  min-height: 32px;
  padding: 0;
  color: var(--secondary_text);
}

@media (pointer: coarse) {
  .action-button.action-button {
    min-width: 44px;
    min-height: 44px;
  }
}
